import { TooltipComponent } from '@clarke-energia/foton-v2';

import React from 'react';

interface IDocumentSection {
  title: string;
  children: React.ReactNode;
  tooltip?: string;
}

export const DocumentSection = ({ title, children, tooltip }: IDocumentSection): JSX.Element => {
  return (
    <div className="w-screen-md flex flex-col justify-start items-start">
      <div className="self-stretch flex flex-col justify-start items-start gap-1">
        <div className="justify-start flex gap-2 text-black text-sm font-normal font-['Inter'] leading-tight">
          {title}
          {tooltip && (
            <TooltipComponent
              icon={{
                icon: 'InformationCircleIcon',
              }}
              side="right"
              content={tooltip}
            />
          )}
        </div>
        <div className="self-stretch flex flex-col justify-start items-start gap-4">{children}</div>
      </div>
    </div>
  );
};
